// Build-time configuration. Production must point at the deployed Supabase functions over HTTPS.
export function resolveApiBase(env: { PROD: boolean; VITE_API_BASE?: string }): string {
  const raw = (env.VITE_API_BASE ?? '').trim().replace(/\/+$/, '');
  if (env.PROD) {
    if (!raw) throw new Error('VITE_API_BASE is not set for this production build');
    if (!raw.startsWith('https://')) throw new Error('VITE_API_BASE must use https in production');
    return raw;
  }
  return raw || 'http://localhost:8787';
}
